import { SVGProps } from "react";

const IconAdmin = (props: SVGProps<SVGSVGElement>) => (
    <svg
        width="100%"
        height="100%"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth={1.8}
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden
        {...props}
    >
        <circle cx="12" cy="7" r="4" />
        <path d="M5 20.5a7 7 0 0 1 10.8-5.9" />
        <circle cx="18.2" cy="18.2" r="1.9" />
        <circle cx="18.2" cy="18.2" r="3.1" />
        <path d="M21.3 18.2h1.2M15.1 18.2h-1.2M18.2 21.3v1.2M18.2 15.1v-1.2M20.4 20.4l.9.9M16 16l-.9-.9M16 20.4l-.9.9M20.4 16l.9-.9" />
    </svg>
);

export default IconAdmin;
